import React from 'react';
import { Box, Typography, useTheme, Theme } from '@mui/material';

const donutColor = (passRate: number, totalChecks: number, theme: Theme) => {
  if (totalChecks === 0) return theme.palette.grey[500];
  if (passRate >= 80) return theme.palette.success.main;
  if (passRate >= 50) return theme.palette.warning.main;
  return theme.palette.error.main;
};

export const Donut: React.FC<{
  passed: number;
  total: number;
  size?: number;
}> = ({ passed, total, size = 64 }) => {
  const theme = useTheme();
  const pct = total === 0 ? 0 : (passed / total) * 100;
  const color = donutColor(pct, total, theme);
  const trackColor = theme.palette.action.disabledBackground;
  const ringThickness = size * 0.16;
  return (
    <Box
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        background:
          total === 0
            ? trackColor
            : `conic-gradient(${color} 0% ${pct}%, ${trackColor} ${pct}% 100%)`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        flexShrink: 0,
      }}
    >
      <Box
        style={{
          position: 'absolute',
          width: size - ringThickness * 2,
          height: size - ringThickness * 2,
          borderRadius: '50%',
          background: theme.palette.background.paper,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      >
        <Typography
          style={{
            fontSize: size * 0.22,
            fontWeight: 700,
            lineHeight: 1,
          }}
        >
          {total === 0 ? '—' : `${Math.round(pct)}%`}
        </Typography>
        {size >= 80 && total > 0 && (
          <Typography
            variant="caption"
            color="textSecondary"
            style={{ fontSize: size * 0.11, marginTop: 2 }}
          >
            {passed} / {total}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
